import { storage } from "../../databases/firebase";
import { getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";

const imageListRef = ref(storage, 'internet-idol-faceoff/');

function createImageRef(_imageID = null, imageCategory=null) {
   if (imageCategory === 'user') {
      return _imageID ? ref(storage, `internet-idol-faceoff/images/users/${_imageID}`) : null;
   } else if (imageCategory === 'challenge') {
      return _imageID ? ref(storage, `internet-idol-faceoff/images/challenge-covers/${_imageID}`) : null;
   } else if (imageCategory === 'video') {
      return _imageID ? ref(storage, `internet-idol-faceoff/videos/${_imageID}`) : null;
   } else {
      alert(`The image category you entered (${imageCategory}) is INVALID!!!`);
      return;
   }
}

export function getVideosFromFBStorage() {
   const videosRef = ref(storage, "internet-idol-faceoff/videos/")
   return listAll(videosRef);
}

export function uploadAndRetrieveFiles(_imageID, desktopFile, imageCategory) {
   if (!_imageID || !desktopFile) {
      alert(`Please enter a valid _imageID or desktopImage as arguments in uploadImage function. You currently have an image id of ${_imageID} and your desktopFile is ${desktopFile}.`);
      return;
   } else {
      console.log({ desktopFile });
   }

   return uploadBytes(createImageRef(_imageID, imageCategory), desktopFile); //This is a PROMISE. You can use a try/catch to verify if the image was successfully uploaded (or just check Firebase storage);
}